import AvailabilityBySourceDrawer from 'components/availability-by-source-drawer';
import AvailabilityByDateDrawer from 'components/availability-by-date-drawer';
import { secondaryAvailabilityTypes } from './types';
import { Conditional } from '@cat-ecom/pcc-components';

const SecondaryAvailability = ({
  showSourcingDetailToggle,
  sourcingDetails,
  availabilityData,
  address,
  hideSourceAndDates = true,
  isPCC_PDP_headerUpdateMobileView,
  isPDPPage
}: secondaryAvailabilityTypes) => {
  return (
    hideSourceAndDates && (
      <Conditional
        test={!showSourcingDetailToggle}
        fallback={
          <AvailabilityByDateDrawer
            availability={availabilityData}
            address={address}
          />
        }
      >
        <AvailabilityBySourceDrawer
          sourcingDetails={sourcingDetails}
          address={address}
          isPDPPage={isPDPPage}
          isPCC_PDP_headerUpdateMobileView={isPCC_PDP_headerUpdateMobileView}
        />
      </Conditional>
    )
  );
};

export default SecondaryAvailability;
